import {
  ApartmentOutlined,
  CameraOutlined,
  ContainerOutlined,
  DesktopOutlined,
  InsertRowBelowOutlined,
  InsuranceOutlined,
  LineChartOutlined,
  OneToOneOutlined,
  PlaySquareOutlined,
  ProjectOutlined,
  RadiusUprightOutlined,
  SafetyCertificateOutlined,
  SolutionOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { lazy } from 'react'

import { ResourceMap } from '@/utils/consts'
import { isInvalidData, reportEventAegis } from '@/utils/util'

export const getManageCenterRoutes = (
  manageCenterResource: ResourceMap['manageCenter'],
  userInfo: UserInfo,
  apiUserResources: UserResources
) => {
  const manageCenterRoutes: Routes = [
    {
      path: '/manageCenter',
      name: '管理中心',
      resource: manageCenterResource.index,
      component: require('../app/ManageLayout').default,
      routes: [
        {
          name: '数据看板',
          icon: <LineChartOutlined />,
          resource: manageCenterResource.manageStatistics,
          path: '/manageCenter/statisticalData',
          component: lazy(() => import('../pages/manageCenter/statisticalData')),
        },
        {
          path: '/manageCenter/authManage',
          name: '权限管理',
          icon: <SafetyCertificateOutlined />,
          resource: manageCenterResource.authManage,
          routes: [
            {
              name: '用户管理',
              resource: manageCenterResource.userManage,
              path: '/manageCenter/authManage/userManage',
              component: lazy(() => import('../pages/manageCenter/authManage/userManage')),
            },
            {
              name: '角色管理',
              resource: manageCenterResource.roleManage,
              path: '/manageCenter/authManage/roleManage',
              component: lazy(() => import('../pages/manageCenter/authManage/roleManage')),
            },
          ],
        },
        {
          path: '/manageCenter/operationManagement',
          name: '运营管理',
          icon: <DesktopOutlined />,
          resource: manageCenterResource.operationDashboard,
          routes: [
            {
              name: '实体列表',
              resource: manageCenterResource.operationCityList,
              path: '/manageCenter/operationManagement/entityList',
              component: lazy(() => import('../pages/manageCenter/operationManage/entityList')),
            },
            {
              name: '落地城市分析',
              resource: manageCenterResource.operationCityAnalysis,
              path: '/manageCenter/operationManagement/cityAnalysis',
              component: lazy(() => import('../pages/manageCenter/operationManage/cityAnalysis')),
            },
          ],
        },
        {
          name: '企业管理',
          icon: <SolutionOutlined />,
          resource: manageCenterResource.enterpriseManage,
          path: '/manageCenter/enterprise',
          routes: [
            {
              name: '企业管理',
              resource: manageCenterResource.enterpriseManageList,
              path: '/manageCenter/enterprise/enterpriseManage',
              component: lazy(() => import('../pages/manageCenter/enterprise/enterpriseManage')),
            },
            {
              name: '考核配置',
              resource: manageCenterResource.examineConfig,
              path: '/manageCenter/enterprise/examineConfig',
              component: lazy(() => import('../pages/manageCenter/enterprise/examineConfig')),
            },
            {
              name: '企业考核总览',
              resource: manageCenterResource.examineOverview,
              path: '/manageCenter/enterprise/examineOverview',
              component: lazy(() => import('../pages/manageCenter/enterprise/examineOverview')),
            },
          ],
        },
        {
          name: '管理员管理',
          icon: <UserOutlined />,
          resource: manageCenterResource.administratorManage,
          path: '/manageCenter/administratorManage',
          component: lazy(() => import('../pages/manageCenter/administratorManage')),
        },
        {
          name: '实体管理',
          icon: <ProjectOutlined />,
          resource: manageCenterResource.entityManage,
          path: '/manageCenter/entityManage',
          component: lazy(() => import('../pages/manageCenter/entityManage')),
        },
        {
          name: '未备案数据过滤记录',
          icon: <InsertRowBelowOutlined />,
          resource: manageCenterResource.unregisteredFilterRecord,
          path: '/manageCenter/unregisteredFilterRecord',
          component: lazy(() => import('../pages/manageCenter/unregisteredFilterRecord')),
        },
        {
          name: '城市全量投放车辆维护入口',
          icon: <InsertRowBelowOutlined />,
          resource: manageCenterResource.cityVehiclePool,
          path: '/manageCenter/cityVehiclePool',
          component: lazy(() => import('../pages/manageCenter/cityVehiclePool')),
        },
        {
          name: '品牌管理',
          icon: <ProjectOutlined />,
          resource: manageCenterResource.brandManage,
          path: '/manageCenter/brandManage',
          component: lazy(() => import('../pages/manageCenter/brandManage')),
        },
        {
          name: '车辆管理',
          icon: <InsertRowBelowOutlined />,
          resource: manageCenterResource.bikeManage,
          path: '/manageCenter/bikeManage',
          routes: [
            {
              name: '重码提醒配置',
              resource: manageCenterResource.bikeAnticheatStrategyManage,
              path: '/manageCenter/bikeManage/duplicateCodeReminder',
              component: lazy(
                () => import('../pages/manageCenter/bikeManage/duplicateCodeReminder')
              ),
            },
            {
              name: '重码识别记录',
              resource: manageCenterResource.bikeAnticheatRecordManage,
              path: '/manageCenter/bikeManage/duplicateCodeRecord',
              component: lazy(() => import('../pages/manageCenter/bikeManage/duplicateCodeRecord')),
            },
            {
              name: '车辆备案管理',
              resource: manageCenterResource.bikeRecordManage,
              path: '/manageCenter/bikeManage/recordManage',
              component: lazy(() => import('../pages/manageCenter/bikeManage/recordManage')),
            },
            {
              name: '车辆定位上报管理',
              resource: manageCenterResource.bikeManageReportPositionMenu,
              path: '/manageCenter/bikeManage/bikeReportPositionManage',
              component: lazy(
                () => import('../pages/manageCenter/bikeManage/bikeReportPositionManage')
              ),
            },
            {
              name: '车辆核验信息',
              resource: manageCenterResource.verificationMenu,
              path: '/manageCenter/bikeManage/verificationManage',
              component: lazy(() => import('../pages/manageCenter/bikeManage/verificationManage')),
            },
            {
              name: '扣车管理',
              resource: manageCenterResource.bikeImpoundMenu,
              path: '/manageCenter/bikeManage/detainCarManage',
              component: lazy(() => import('../pages/manageCenter/bikeManage/detainCarManage')),
            },
          ],
        },
        {
          name: '任务中心',
          icon: <DesktopOutlined />,
          resource: manageCenterResource.taskCenter,
          path: '/manageCenter/taskCenter',
          component: lazy(() => import('../pages/manageCenter/taskCenter')),
        },
        {
          name: '围栏管理',
          icon: <RadiusUprightOutlined />,
          resource: manageCenterResource.fenceManageList,
          path: '/manageCenter/fenceManage',
          routes: [
            {
              name: '全部围栏',
              resource: manageCenterResource.fenceManageAllFence,
              path: '/manageCenter/fenceManage/allFences',
              component: lazy(() => import('../pages/manageCenter/fenceManage/allFences')),
            },
            {
              name: '围栏淤积统计',
              resource: manageCenterResource.fenceManageDeposition,
              path: '/manageCenter/fenceManage/depositStatistic',
              component: lazy(() => import('../pages/manageCenter/fenceManage/depositStatistic')),
            },
            {
              name: '秩序重点区域',
              resource: manageCenterResource.fenceManageOrderKeyRegion,
              path: '/manageCenter/fenceManage/orderKeyRegion',
              component: lazy(() => import('../pages/manageCenter/fenceManage/orderKeyRegion')),
            },
          ],
        },
        {
          name: '运维信息',
          icon: <DesktopOutlined />,
          resource: manageCenterResource.operationManage,
          path: '/manageCenter/operationManage',
          component: lazy(() => import('../pages/manageCenter/operationManage')),
        },
        {
          name: '拍照识别溯源',
          icon: <CameraOutlined />,
          resource: manageCenterResource.photographMangeMenu,
          path: '/manageCenter/photographMange',
          component: lazy(() => import('../pages/manageCenter/photographManage')),
        },
        {
          name: '订单管理',
          icon: <ContainerOutlined />,
          resource: manageCenterResource.orderManage,
          path: '/manageCenter/orderManage',
          component: lazy(() => import('../pages/manageCenter/orderManage')),
        },
        {
          name: '蓝牙嗅探',
          icon: <OneToOneOutlined />,
          resource: manageCenterResource.bluetoothSniff,
          path: '/manageCenter/bluetoothSniff',
          routes: [
            {
              name: '蓝牙嗅探记录',
              resource: manageCenterResource.bluetoothSniffRecordMenu,
              path: '/manageCenter/bluetoothSniff/bluetoothSniffRecord',
              component: lazy(
                () => import('../pages/manageCenter/bluetoothSniff/bluetoothSniffRecord')
              ),
            },
            {
              name: '嗅探车辆明细',
              resource: manageCenterResource.bluetoothSniffDetailMenu,
              path: '/manageCenter/bluetoothSniff/bluetoothSniffDetail',
              component: lazy(
                () => import('../pages/manageCenter/bluetoothSniff/bluetoothSniffDetail')
              ),
            },
          ],
        },
        {
          name: '秩序管理',
          icon: <SolutionOutlined />,
          resource: manageCenterResource.orderlyManage,
          path: '/manageCenter/orderlyManage',
          routes: [
            {
              name: '重点区域表现',
              resource: manageCenterResource.keyRegionPerform,
              path: '/manageCenter/orderlyManage/keyRegionPerform',
              component: lazy(() => import('../pages/manageCenter/orderlyManage/keyRegionPerform')),
            },
            {
              name: '智能巡检明细',
              resource: manageCenterResource.keyOrderlyDetail,
              path: '/manageCenter/orderlyManage/intelligentInspection',
              component: lazy(
                () => import('../pages/manageCenter/orderlyManage/intelligentInspection')
              ),
            },
          ],
        },
        {
          name: '调查取证',
          icon: <InsuranceOutlined />,
          resource: manageCenterResource.inquiryEvidence,
          path: '/manageCenter/inquiryEvidence',
          component: lazy(() => import('../pages/manageCenter/inquiryEvidence')),
        },
        {
          path: '/manageCenter/nationalStandardVideo',
          name: '摄像头管理',
          resource: manageCenterResource.cameraManage,
          icon: <PlaySquareOutlined />,
          routes: [
            {
              path: '/manageCenter/nationalStandardVideo/deviceManage',
              name: '通道管理',
              resource: manageCenterResource.cameraChannelManage,
              component: lazy(
                () => import('../pages/manageCenter/nationalStandardVideo/deviceManage')
              ),
            },
            {
              path: '/manageCenter/nationalStandardVideo/serviceConfig',
              name: '服务配置',
              resource: manageCenterResource.cameraConfigManage,
              component: lazy(
                () => import('../pages/manageCenter/nationalStandardVideo/serviceConfig')
              ),
            },
          ],
        },
        {
          name: 'API管理',
          icon: <ApartmentOutlined />,
          resource: manageCenterResource.apiManagement,
          path: '/manageCenter/apiConfigManage',
          component: lazy(() => import('../pages/manageCenter/apiConfigManage')),
        },
        {
          name: '数据开放平台',
          icon: <ProjectOutlined />,
          resource: manageCenterResource.manageOpenapi,
          path: '/manageCenter/openApiManage',
          routes: [
            {
              path: '/manageCenter/openApiManage/config',
              name: '数据开放API配置',
              resource: manageCenterResource.manageOpenapiConfig,
              component: lazy(() => import('../pages/manageCenter/openApiManage/config/index')),
            },
          ],
        },
        {
          name: '违规告警',
          resource: manageCenterResource.violationAlarm,
          icon: <InsertRowBelowOutlined />,
          path: '/manageCenter/violationAlarm',
          routes: [
            {
              path: '/manageCenter/violationAlarm/violationReference',
              name: '车辆未备案',
              resource: manageCenterResource.violationAlarmList,
              component: lazy(
                () => import('../pages/manageCenter/violationWarning/violationAlarm')
              ),
            },
            {
              path: '/manageCenter/violationAlarm/stationRepayBike',
              name: '站点外还车',
              resource: manageCenterResource.violationStationMenu,
              component: lazy(
                () => import('../pages/manageCenter/violationWarning/stationRepayBike')
              ),
            },
            {
              path: '/manageCenter/violationAlarm/noParkBike',
              name: '禁停区停车',
              resource: manageCenterResource.violationNoParkingMenu,
              component: lazy(() => import('../pages/manageCenter/violationWarning/noParkBike')),
            },
            // {
            //   path: '/manageCenter/violationAlarm/noPutBike',
            //   name: '禁投区投车',
            //   resource: manageCenterResource.violationAlarm,
            //   component: lazy(() => import('../pages/manageCenter/violationWarning/noPutBike')),
            // },
          ],
        },
        { path: '*', component: require('../pages/notFound').default },
      ],
    },
  ]
  try {
    const routes: any = [...manageCenterRoutes]
    routes[0].routes = setRouterSorted(routes[0].routes, apiUserResources)
    return routes
  } catch (e: any) {
    console.log('getManageCenterRoutes error', e.message)
    reportEventAegis({
      name: 'getManageCenterRoutes error',
      ext1: e.message,
    })
    return manageCenterRoutes
  }
}

const setRouterSorted = (routers: Routes, apiUserResources: UserResources): any[] => {
  routers.forEach(router => {
    const resource = apiUserResources.find(apiResource => {
      return apiResource.id === router.resource?.id
    })
    if (resource && !isInvalidData(resource?.sorted)) {
      router.sorted = resource?.sorted
      router.name = resource?.resourceName
    }
    if (router.routes) {
      router.routes = setRouterSorted(router.routes, apiUserResources)
    }
  })
  return routers
    .filter((router: any) => !isInvalidData(router.sorted))
    .sort((pre: any, next: any) => {
      if (!isInvalidData(pre.sorted) && !isInvalidData(next.sorted)) {
        return pre.sorted - next.sorted
      }
      return 0
    })
}
